module.exports = __webpack_public_path__ + "media/images/receipt-template-mobile_app-bdcb96d90c28871779d27113d576b1f0.png";